import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addError } from 'actions';
import { updateAssessmentStatus, createAssessments, updateAssessment } from 'actions/assessments';
import SimpleSelect from 'components/Inputs/SimpleSelect';
import AssessmentForm from 'containers/Forms/AssessmentForm';
import ClearBlockAssessments from 'containers/Forms/Assessment/ClearBlockAssessments';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import swal from 'sweetalert2';
import { Icon, Checkbox, Button } from '@haldor/ui';
import api from 'lib/api';
import sniffer from 'sniffer';

var UserPlanning = /*#__PURE__*/function (_Component) {
  _inherits(UserPlanning, _Component);

  var _super = _createSuper(UserPlanning);

  function UserPlanning(props) {
    var _this;

    _classCallCheck(this, UserPlanning);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then(function () {
            resolve(1);

            _this.closeAssessment();
          });

          return true;
        }

        var selectedUsers = _this.props.items.filter(function (t) {
          return t.selected;
        });

        var data = [];
        selectedUsers.forEach(function (user) {
          data.push(_objectSpread(_objectSpread({}, values), {}, {
            studentId: user.id
          }));
        });

        _this.props.createAssessments(data).then(function () {
          resolve(1);

          _this.closeAssessment();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (item, value) {
      var userObj = {
        id: item.id,
        firstname: item.firstname,
        lastname: item.lastname,
        planId: item.planId,
        status: value.value
      };
      api.put("planning/student/status", userObj).then(function () {
        _this.props.addError(_this.props.translate('changes-saved'), 'info');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentStatusSelect", function (item, value) {
      var assessment = _this.props.assessments.find(function (t) {
        return t.studentId == item.id;
      });

      if (assessment != null) {
        _this.props.updateAssessmentStatus(assessment.id, value.value).then(function () {
          _this.props.addError(_this.props.translate('changes-saved'), 'info');
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "markForConversation", function (student) {
      if (_this.props.onConversation != null) {
        _this.props.onConversation(student);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeAssessment", function () {
      _this.props.reload();

      _this.setState({
        assessmentOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openAssessment", function (user) {
      if (user != null) {
        _this.props.items.forEach(function (t) {
          return t.selected = false;
        });

        user.selected = true;
      } else {
        _this.props.items.forEach(function (student) {
          var assessment = _this.props.assessments.find(function (t) {
            return t.studentId == student.id;
          });

          if (assessment != null) {
            student.selected = false;
          }
        });
      }

      var selectedUsers = _this.props.items.filter(function (t) {
        return t.selected;
      });

      if (selectedUsers.length > 0) {
        _this.setState({
          assessmentOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "publishAllAssessments", function () {
      var _this$props = _this.props,
          addError = _this$props.addError,
          translate = _this$props.translate,
          assessments = _this$props.assessments;
      var items = _this.props.items;
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('publish-all-assessments-warning'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('yes-publish')
      }).then(function (result) {
        if (result.value != null) {
          var requests = 0;
          items.map(function (user) {
            var userAssessment = assessments.find(function (ass) {
              return ass.studentId == user.id;
            });

            if (userAssessment != null) {
              if (userAssessment.status != 'ASSESSMENT_PUBLISHED') {
                requests++;
                api.put("assessments/status?assessmentId=".concat(userAssessment.id, "&status=ASSESSMENT_PUBLISHED"), null).then(function () {
                  requests--;

                  if (requests == 0) {
                    addError(translate('changes-saved'), 'info');

                    _this.props.reload();
                  }
                });
              }
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (user, checked) {
      user.selected = checked;

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "onCheckAll", function (checked) {
      _this.props.items.forEach(function (t) {
        return t.selected = checked;
      });

      _this.setState({});
    });

    _this.state = {
      assessmentOpen: false,
      removeAssessments: false
    };

    _this.onCheckAll.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(UserPlanning, [{
    key: "renderStudents",
    value: function renderStudents() {
      var _this2 = this;

      var items = this.props.items;
      return items.sort(function (a, b) {
        return a.lastname.localeCompare(b.lastname);
      }).map(function (user, index) {
        var _assessment;

        var assessment = null;

        if (_this2.props.assessments != null) {
          assessment = _this2.props.assessments.find(function (t) {
            return t.studentId == user.id;
          });
        }

        var conversation = null;

        if (_this2.props.conversations != null) {
          conversation = _this2.props.conversations.find(function (conv) {
            return conv.memberships.find(function (member) {
              return member.membershipID == user.id;
            });
          });
        }

        return /*#__PURE__*/React.createElement("tr", {
          key: index + '-id-' + user.id,
          className: "no-hover"
        }, _this2.props.printable ? null : /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Checkbox, {
          value: user.selected,
          onChange: function onChange(checked) {
            return _this2.onSelect(user, checked);
          }
        })), /*#__PURE__*/React.createElement("td", {
          className: "name"
        }, /*#__PURE__*/React.createElement(Link, {
          to: "#",
          style: {
            cursor: 'pointer',
            textDecoration: 'underline',
            color: '#363636'
          },
          onClick: function onClick() {
            return _this2.openAssessment(user);
          }
        }, user.firstname, " ", user.lastname)), sniffer.isPhone ? null : /*#__PURE__*/React.createElement("td", {
          className: "status",
          style: {
            textAlign: 'left'
          }
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: user.status,
          disabled: _this2.props.allowStatus != null ? !_this2.props.allowStatus : _this2.props.printable,
          name: "assessment-status",
          item: user,
          type: "planning",
          onChange: _this2.onStatusSelect
        })), _this2.props.printable ? null : /*#__PURE__*/React.createElement("td", {
          className: "status"
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          selectedValue: (_assessment = assessment) === null || _assessment === void 0 ? void 0 : _assessment.status,
          disabled: assessment == null || _this2.props.printable,
          name: "assessment-status",
          item: user,
          type: "assessment",
          onChange: _this2.onAssessmentStatusSelect
        })), _this2.props.printable || sniffer.isPhone ? null : /*#__PURE__*/React.createElement("td", {
          className: "make_assessment"
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick() {
            return _this2.openAssessment(user);
          },
          type: "secondary"
        }, _this2.props.translate('assess'))), _this2.props.services.conversations && _this2.props.onConversation != null ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
          to: "#",
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick(e) {
            return _this2.markForConversation(user);
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '1.75rem',
            position: 'relative'
          }
        }, conversation != null ? /*#__PURE__*/React.createElement(Icon, {
          name: "Message"
        }) : /*#__PURE__*/React.createElement(Icon, {
          name: "Message",
          bw: true
        }), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null))) : null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var selectedUsers = this.props.items.filter(function (t) {
        return t.selected;
      });
      var unpublishedAssessment = null;
      var disableAssessmentsButton = true;
      var disableRemoveAssessmentButton = true;

      if (this.props.assessments != null) {
        unpublishedAssessment = this.props.assessments.find(function (ass) {
          return ass.status != 'ASSESSMENT_PUBLISHED';
        });
        disableAssessmentsButton = true;

        if (unpublishedAssessment != null) {
          disableAssessmentsButton = false;
        }
      }

      selectedUsers.forEach(function (user) {
        if (user.id != null) {
          var hasAssessment = null;

          if (_this3.props.assessments != null) {
            hasAssessment = _this3.props.assessments.findIndex(function (ass) {
              return ass.studentId == user.id;
            });
          }

          if (hasAssessment > -1) {
            disableRemoveAssessmentButton = false;
          }
        }
      });
      var assessmentBlocks = null;
      var assessment = null;

      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      if (selectedUsers.length == 1 && this.props.assessments != null) {
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.studentId == selectedUsers[0].id;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.assessmentOpen,
        onClose: this.closeAssessment,
        title: this.props.translate('Assessment')
      }, /*#__PURE__*/React.createElement(AssessmentForm, {
        onSubmit: this.onAssessmentSubmit,
        onClose: this.closeAssessment,
        initialValues: assessment,
        items: selectedUsers,
        blocks: assessmentBlocks,
        referenceId: this.props.planId,
        referenceType: "Plan"
      })), /*#__PURE__*/React.createElement(Modal, {
        overridePrompt: true,
        isOpen: this.state.removeAssessments,
        type: "small",
        title: this.props.translate('Remove assessments'),
        onClose: function onClose() {
          return _this3.setState({
            removeAssessments: false
          });
        }
      }, /*#__PURE__*/React.createElement(ClearBlockAssessments, {
        items: selectedUsers.map(function (x) {
          return {
            assignedTo: x.id,
            groupName: "".concat(x.firstname, " ").concat(x.lastname)
          };
        }),
        assessments: this.props.assessments,
        section: this.props.section,
        onAbort: function onAbort(reload) {
          if (reload) _this3.props.reload(true);

          _this3.setState({
            removeAssessments: false
          });
        }
      })), /*#__PURE__*/React.createElement("table", {
        className: "status-list"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, this.props.printable ? null : /*#__PURE__*/React.createElement("th", {
        style: {
          padding: '1em 1.5em'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(event) {
          return _this3.onCheckAll(event);
        }
      })), /*#__PURE__*/React.createElement("th", null, this.props.translate('name')), sniffer.isPhone ? null : /*#__PURE__*/React.createElement("th", null, this.props.translate('Status')), this.props.printable ? null : /*#__PURE__*/React.createElement("th", null, this.props.translate('assessment-status')), /*#__PURE__*/React.createElement("th", null), this.props.services.conversations ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", null, this.renderStudents())), /*#__PURE__*/React.createElement("div", null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: selectedUsers.length == 0,
        style: {
          marginLeft: '1rem',
          marginBottom: '0.5em'
        },
        onClick: function onClick() {
          return _this3.openAssessment();
        }
      }, this.props.translate('assess-selected-students')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        disabled: disableAssessmentsButton,
        style: {
          marginLeft: '1rem',
          marginBottom: '0.5em'
        },
        onClick: function onClick() {
          return _this3.publishAllAssessments();
        }
      }, this.props.translate('publish-assessments')) : null, !this.props.printable ? /*#__PURE__*/React.createElement(Button, {
        style: {
          marginLeft: '1rem',
          marginBottom: '0.5em'
        },
        disabled: disableRemoveAssessmentButton || selectedUsers.length == 0,
        onClick: function onClick() {
          return _this3.setState({
            removeAssessments: true
          });
        }
      }, this.props.translate('Remove assessments')) : null));
    }
  }]);

  return UserPlanning;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    conversations: state.Conversation.referenceConversations,
    assessments: state.assessments.assessments,
    translate: translate(state.Languages.translations),
    section: state.planning.section,
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  addError: addError,
  updateAssessmentStatus: updateAssessmentStatus,
  createAssessments: createAssessments,
  updateAssessment: updateAssessment
})(UserPlanning);